import { render, staticRenderFns } from "./CategoryItemView.vue?vue&type=template&id=51cf2c66&scoped=true&"
import script from "./CategoryItemView.vue?vue&type=script&lang=js&"
export * from "./CategoryItemView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItemView.vue?vue&type=style&index=0&id=51cf2c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf2c66",
  null
  
)

export default component.exports